import { render, staticRenderFns } from "./Cocina.vue?vue&type=template&id=7246629f"
import script from "./Cocina.vue?vue&type=script&lang=js"
export * from "./Cocina.vue?vue&type=script&lang=js"
import style0 from "./Cocina.vue?vue&type=style&index=0&id=7246629f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports